import { IFamocoTranslations } from '..';

const famoco: IFamocoTranslations = {
  famoco_settings: 'Configurações Famoco',
  api_token: 'API Token',
  api_token_placeholder: 'Insira o API token da interface Famoco',
  has_api_token: 'API token',
  token_not_set: 'Não configurado',
  token_is_set: 'Configurado',
  org_id: 'ID da organização',
  org_id_placeholder: 'Insira o ID da organização (ex: 1487)',
  base_url: 'URL base',
  base_url_placeholder: 'https://my.famoco.com',
  save_config: 'Guardar configuração',
  sync_fleets: 'Sincronizar frotas',
  fleets: 'Frotas',
  fleet_name: 'Nome da frota',
  famoco_id: 'Famoco ID',
  not_configured: 'O Famoco não está configurado. Insira as credenciais da API para começar.',
  no_fleets: 'Nenhuma frota sincronizada. Clique em "Sincronizar frotas" após guardar a configuração.',
  config_saved: 'Configuração guardada.',
  fleets_synced: 'Frotas sincronizadas com sucesso.',
  config_error: 'Falha ao guardar a configuração.',
  sync_error: 'Falha ao sincronizar as frotas.',
  updated_at: 'Última atualização',
  sync_devices: 'Sincronizar dispositivos',
  sync_devices_error: 'Falha ao sincronizar os dispositivos.',
  famoco_devices: 'Dispositivos Famoco',
  in_fleet: 'Em frota',
  in_stock: 'Em stock',
  licenses: 'Licenças',
  api_token_placeholder_update: 'Insira um novo token para substituir o existente',
  validate_token: 'Validar token',
  validating: 'A validar…',
  token_valid: 'Token válido',
  validation_error: 'Validação do token falhou.',
  select_org: 'Selecionar organização',
  org: 'Organização',
  save_and_sync: 'Guardar e sincronizar',
  saving_and_syncing: 'A guardar e sincronizar…',
  save_and_sync_success: 'Configuração guardada e sincronizada.',
  sync_all: 'Sincronizar estado Famoco',
  sync_all_success: 'Estado Famoco sincronizado.',
  sync_all_error: 'Sincronização falhou.',
  update_token: 'Atualizar token',
  cancel: 'Cancelar'
};

export default famoco;
